import { render, staticRenderFns } from "./HomePageMediaQuotes.vue?vue&type=template&id=4c5508c4&scoped=true&"
import script from "./HomePageMediaQuotes.vue?vue&type=script&lang=js&"
export * from "./HomePageMediaQuotes.vue?vue&type=script&lang=js&"
import style0 from "./HomePageMediaQuotes.vue?vue&type=style&index=0&id=4c5508c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5508c4",
  null
  
)

export default component.exports